import { useDispatch, useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import parentStyles from '../dashboardTables.module.scss';
import specificStyles from './conversionTimeTable.module.scss';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import HeaderCell from '../components/HeaderCell';
import { TABLE_SORT_FIELDS } from '../../constants';
import ConversionTimeGroupedTableContent from './ConversionTimeGroupedTableContent';
import ConversionTimeNonGroupedTableContent from './ConversionTimeNonGroupedTableContent';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

export default function ConversionTimeTable() {
  const dispatch = useDispatch();
  const { conversionTime } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const track = useTrackPerformanceTable();

  const headers = [
    {
      id: 1,
      title: Trans(translations, 'Agent'),
      subtitle: Trans(translations, 'Branch'),
      field: TABLE_SORT_FIELDS.AGENT_NAME,
    },
    {
      id: 2,
      title: Trans(translations, 'ConversionTime'),
      field: TABLE_SORT_FIELDS.CONVERSION_TIME,
    },
    {
      id: 3,
      title: Trans(translations, 'Contact'),
      field: TABLE_SORT_FIELDS.CONTACT_NAME,
    },

    {
      id: 4,
      title: Trans(translations, 'PropertyType'),
      field: TABLE_SORT_FIELDS.PROPERTY_TYPE,
    },
    {
      id: 5,
      title: Trans(translations, 'Location'),
      field: TABLE_SORT_FIELDS.LOCATION,
    },
    {
      id: 6,
      title: Trans(translations, 'Operation'),
      field: TABLE_SORT_FIELDS.OPERATION,
    },
    {
      id: 7,
      title: Trans(translations, 'Value'),
      field: TABLE_SORT_FIELDS.OPERATION_AMOUNT,
    },
  ];

  const handleCellClick = (header) => {
    dispatch(
      setPerformanceModals({
        key: 'conversionTime',
        subkey: 'sortBy',
        value: header.field,
      })
    );
    track.conversionTime(TRACK_ELEMENT.COLUMN_ORDER);
  };

  return (
    <Table
      id="conversion-time-table"
      className={`${parentStyles.table} ${specificStyles.conversionTimeTable}`}
    >
      <Table.Header className={parentStyles.tableHeader}>
        {headers.map((header) => (
          <HeaderCell
            key={header.id}
            id={header.id}
            title={header.title}
            subtitle={header.subtitle}
            field={header.field}
            sortBy={conversionTime.sortBy}
            sortDirection={conversionTime.sortDirection}
            onClick={() => handleCellClick(header)}
          />
        ))}
      </Table.Header>

      {conversionTime.groupByBranch ? (
        <ConversionTimeGroupedTableContent headers={headers} />
      ) : (
        <ConversionTimeNonGroupedTableContent headers={headers} />
      )}
    </Table>
  );
}
